import { render } from "./imageChanger.vue?vue&type=template&id=1a471c49"
import script from "./imageChanger.vue?vue&type=script&lang=js"
export * from "./imageChanger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__